/*
 * PCG JS module - homeslick
 */
var HomeSlick = function () {
    var $currentContext = $(document);
    var $slickInst = null;

    var moduleOptions = {
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 540,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    $(window).resize(function() {
        $('.js-pcg-slider').slick('resize');
    });

    $(window).on('orientationchange', function() {
        $('.js-pcg-slider').slick('resize');
    });

    function extendSlick() {
        $slickInst.$slideTrack.attr('role', 'list');
        $slickInst.$slides.attr('role', 'listitem');
    }

    function bindEvents() {
        $currentContext.on('init', function (event, slick) {
            $slickInst = slick;
        });
    }

    function initSlick() {
        $currentContext.slick(moduleOptions);
    }

    this.init = function (context, options) {
        $currentContext = context || $currentContext;
        $.extend(moduleOptions, options);

        bindEvents();
        initSlick();
        extendSlick();
    };

    return this;
};

module.exports = HomeSlick;
